import { TransactionFlagDto } from './dtos/transactions'
import { match, DEFAULT } from '../utils/pattern-match-util'

export const enum TransactionFlag {
  Unknown = 'Unknown',
  JobCanceled = 'JobCanceled',
  JobPayoutAutoAdjusted = 'JobPayoutAutoAdjusted',
}

export function parseTransactionFlag(dto: TransactionFlagDto): TransactionFlag {
  return match(dto, {
    JOB_CANCELED: () => TransactionFlag.JobCanceled,
    JOB_PAYOUT_AUTO_ADJUSTED: () => TransactionFlag.JobPayoutAutoAdjusted,
    [DEFAULT]: () => {
      console.warn('Unknown transaction flag', dto)
      return TransactionFlag.Unknown
    },
  })
}

export function serializeTransactionFlag(
  flag: TransactionFlag,
): TransactionFlagDto {
  return match<TransactionFlag, TransactionFlagDto>(flag, {
    [TransactionFlag.JobCanceled]: () => 'JOB_CANCELED',
    [TransactionFlag.JobPayoutAutoAdjusted]: () => 'JOB_PAYOUT_AUTO_ADJUSTED',
    [TransactionFlag.Unknown]: () => {
      throw new Error(`Cannot serialize unknown transaction flag '${flag}'`)
    },
  })
}
